import React, { useState } from 'react';
import api from '../../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { ExportTrio } from '../accounting/ExportTrio';

const num = (v) => typeof v === 'number';
const fmt = (v) => (num(v) ? Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : String(v ?? ''));

// Drill-down table for one period-summary total; same rows go to Excel/PDF/CSV.
export const PeriodDrilldown = ({ req, params, onClose, onOpen }) => {
  const [data, setData] = useState(null);
  const key = req ? JSON.stringify(req) : '';
  React.useEffect(() => {
    if (!req) return;
    setData(null);
    api.get('/accounting/period-summary/drilldown', { params: { ...params, ...req.q } })
      .then((r) => setData(r.data)).catch(() => setData({ rows: [], error: true }));
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  const rows = data?.rows || [];
  const cols = rows.length ? Object.keys(rows[0]).filter((k) => !k.endsWith('_id') && k !== 'id').map((k) => ({ key: k, label: k.replace(/_/g, ' '), numeric: num(rows[0][k]) })) : [];
  const spec = () => ({ title: req?.title || 'Drilldown', subtitle: `${params.start_date} – ${params.end_date}`, cols, rows });
  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl max-h-[85vh] overflow-hidden flex flex-col" data-testid="period-drilldown-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between gap-3 pr-6">
            <span data-testid="period-drilldown-title">{req?.title}</span>
            <ExportTrio spec={spec} testId="period-drilldown-export" disabled={!rows.length} />
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-auto text-xs" data-testid="period-drilldown-table">
          {!data && <div className="p-4 text-muted-foreground">Loading…</div>}
          {data && !rows.length && <div className="p-4 text-muted-foreground" data-testid="period-drilldown-empty">No rows for the selected filters</div>}
          {rows.length > 0 && (
            <table className="w-full">
              <thead className="sticky top-0 bg-card"><tr>{cols.map((c) => <th key={c.key} className={`px-2 py-1 font-medium capitalize ${c.numeric ? 'text-right' : 'text-left'}`}>{c.label}</th>)}</tr></thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} className={`border-t border-border/40 ${req?.next ? 'cursor-pointer hover:bg-muted/50' : ''}`}
                    onClick={() => req?.next && onOpen(req.next(r))} data-testid={`period-drilldown-row-${i}`}>
                    {cols.map((c) => <td key={c.key} className={`px-2 py-1 ${c.numeric ? 'text-right tabular-nums' : ''}`}>{fmt(r[c.key])}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="text-[10px] text-muted-foreground" data-testid="period-drilldown-count">{rows.length} rows{req?.next ? ' · click a row to open it' : ''}</div>
      </DialogContent>
    </Dialog>
  );
};
